import { useState, useEffect, useContext, useMemo } from 'react';
import { ClientContext } from '../../../../contexts/clientProvider';
import { SecretariasContext } from '../../../../contexts/secretariasProvider';
import LoadingSpinner from '../../../Loader/load';
import DataTable from '../../../Table';
import { FaturadorContext } from '../../../../contexts/faturadorProvider';
import { BiX } from "react-icons/bi";
import FilterDate from '../filterDate';
import FrameSelect from '../../../General/FrameSelect';
import BaseSelect from '../../../General/FormsComp/Select/BaseSelect';

const Setor = () => {
  const { clientes, setIdCliente } = useContext(ClientContext);
  const { grupos, patrimonios, loading, total, calculateTotalByGrupoValor, toBrl, clienteSelecionado, setClienteSelecionado, filterDates, setFilterDates } = useContext(FaturadorContext);
  const { secretarias } = useContext(SecretariasContext);
  const [filteredTotal, setFilteredTotal] = useState(total);
  const [selectedSetor, setSelectedSetor] = useState([]);
  const [selectedModelo, setSelectedModelo] = useState('');
  const [selectedAnexos, setSelectedAnexos] = useState([]);
  const [setor, setSetor] = useState([]);
  const [anexos, setAnexos] = useState([]);
  const [titulo, setTitulo] = useState(null);
  const [filterModal, setFilterModal] = useState(false);
  const [checkUpdate, setCheckUpdate] = useState(false);
  const [newPats, setNewPats] = useState([]);
  const [showAnexos, setShowAnexos] = useState([]);
  const [selectedClient, setSelectedClient] = useState('');
  const [selectedSetorValue, setSelectedSetorValue] = useState('');
  const [selectedModeloValue, setSelectedModeloValue] = useState('');
  const [selectedAnexoValue, setSelectedAnexoValue] = useState('');
  const [selectedGrupos, setSelectedGrupos] = useState([]);
  const [selectedGrupoValue, setSelectedGrupoValue] = useState('');
  const [selectedSecretarias, setSelectedSecretarias] = useState([]);
  const [selectedSecretariaValue, setSelectedSecretariaValue] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [showSelections, setShowSelections] = useState(false);
  const [searchSetor, setSearchSetor] = useState('');
  const [searchAnexo, setSearchAnexo] = useState('');
  const [searchSecretaria, setSearchSecretaria] = useState('');
  const [searchModelo, setSearchModelo] = useState('');
  const [searchGrupo, setSearchGrupo] = useState('');
  const [showSecretarias, setShowSecretarias] = useState([]);
  const [showModelos, setShowModelos] = useState([]);
  const [showGrupos, setShowGrupos] = useState([]);
  const [selectedModelos, setSelectedModelos] = useState([]);

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showFilters && !event.target.closest('.relative')) {
        setShowFilters(false);
      }
      if (showSelections && !event.target.closest('.relative')) {
        setShowSelections(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilters, showSelections]);

  const secretariaOptions = useMemo(() => {
    const currentClientId = String(
      selectedClient || (clientes?.find(c => c?.nome === clienteSelecionado)?.id ?? '')
    );
    if (!currentClientId) return [];
    const list = (secretarias || [])
      .filter(s => String(s?.id_cliente || s?.cliente_id) === currentClientId)
      .map(s => ({ id: String(s?.id), nome: s?.nome }))
      .filter(opt => opt.id && opt.nome);
    return list;
  }, [secretarias, clientes, selectedClient, clienteSelecionado]);


  useEffect(() => {
    if (!clienteSelecionado) return;
    const client = clientes.find((client) => client.nome === clienteSelecionado);
    setIdCliente(client.id);
    setTitulo(client.nome);
  }, []);


  useEffect(() => {
    if (!patrimonios) return;
    // Filtrar patrimonios para excluir anexo "ESTOQUE"
    const patrimoniosFiltered = patrimonios.filter(pat => 
      pat.nome_do_anexo !== "ESTOQUE" && pat.nome_do_anexo !== "Estoque" && pat.nome_do_anexo !== "estoque"
    );
    
    let newPats = patrimoniosFiltered.map((pat) => {
      if (!pat.produto) {
        pat.produto = `${pat.marca_nome} ${pat.modelo_nome}`;
      }
      if (pat.data_implantacao) {
        pat.data_implantacao = formatDate(pat.data_implantacao.split('T')[0]);
        return pat;
      }
      return pat;
    });
    setNewPats(newPats);
  }, [patrimonios]);

  const handleAnexoChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedAnexoValue(selectedValue);
    if (selectedValue === 'Todos' && anexos.length > 1) {
      setSelectedAnexos(prev => {
        const anexosRestantes = anexos.filter((anexo) => anexo !== 'Todos' && !prev.includes(anexo));
        return [...prev, ...anexosRestantes];
      });
      setShowAnexos(prev => {
        const anexosRestantes = anexos.filter((anexo) => anexo !== 'Todos' && !prev.includes(anexo));
        return [...prev, ...anexosRestantes];
      });
    } else {
      setSelectedAnexos(prev => {
        if (!prev.includes(selectedValue) && selectedValue !== 'Todos') {
          return [...prev, selectedValue];
        }
        return prev;
      });
      setShowAnexos(prev => {
        if (!prev.includes(selectedValue) && selectedValue !== 'Todos') {
          return [...prev, selectedValue];
        }
        return prev;
      });
    }
  };

  const handleRemoveAnexo = (index) => {
    setSelectedAnexos(prev => {
      const removedAnexo = prev[index];
      setAnexos(prev => {
        if (!prev.includes(removedAnexo)) {
          return [...prev, removedAnexo];
        }
        return prev;
      });
      return prev.filter((_, i) => i !== index);
    });
    setShowAnexos(prev => {
      const removedAnexo = prev[index];
      setAnexos(prev => {
        if (!prev.includes(removedAnexo)) {
          return [...prev, removedAnexo];
        }
        return prev;
      });
      return prev.filter((_, i) => i !== index);
    });
  };

  const removeAllAnexos = () => {
    setSelectedAnexos([]);
    setShowAnexos([]);
    // Filtrar patrimonios para excluir anexo "ESTOQUE"
    const patrimoniosFiltered = patrimonios.filter(pat => 
      pat.nome_do_anexo !== "ESTOQUE" && pat.nome_do_anexo !== "Estoque" && pat.nome_do_anexo !== "estoque"
    );
    setAnexos(['Todos', ...new Set(patrimoniosFiltered.map(p => p.nome_do_anexo).filter(a => a && a !== null && a !== undefined))]);
  };

  const removeAllSetores = () => {
    setSelectedSetor([]);
    // Filtrar patrimonios para excluir anexo "ESTOQUE"
    const patrimoniosFiltered = patrimonios.filter(pat => 
      pat.nome_do_anexo !== "ESTOQUE" && pat.nome_do_anexo !== "Estoque" && pat.nome_do_anexo !== "estoque"
    );
    setSetor(['Todos', ...new Set(patrimoniosFiltered.map(p => p.setor).filter(s => s && s !== null && s !== undefined))]);
  };

  // Funções para Secretarias
  const handleSecretariaChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedSecretariaValue(selectedValue);
    if (selectedValue === 'Todos' && secretariaOptions.length > 1) {
      setSelectedSecretarias(prev => {
        const secretariasRestantes = secretariaOptions.filter((sec) => !prev.includes(sec.id));
        return [...prev, ...secretariasRestantes.map(s => s.id)];
      });
      setShowSecretarias(prev => {
        const secretariasRestantes = secretariaOptions.filter((sec) => !prev.includes(sec.nome));
        return [...prev, ...secretariasRestantes.map(s => s.nome)];
      });
    } else if (selectedValue !== 'Todos') {
      setSelectedSecretarias(prev => {
        if (!prev.includes(selectedValue)) {
          return [...prev, selectedValue];
        }
        return prev;
      });
      const secretariaNome = secretariaOptions.find(s => s.id === selectedValue)?.nome;
      if (secretariaNome) {
        setShowSecretarias(prev => {
          if (!prev.includes(secretariaNome)) {
            return [...prev, secretariaNome];
          }
          return prev;
        });
      }
    }
  };

  const handleRemoveSecretaria = (index) => {
    setSelectedSecretarias(prev => {
      return prev.filter((_, i) => i !== index);
    });
    setShowSecretarias(prev => {
      return prev.filter((_, i) => i !== index);
    });
  };

  const removeAllSecretarias = () => {
    setSelectedSecretarias([]);
    setShowSecretarias([]);
  };

  // Funções para Modelos
  const handleModeloChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedModeloValue(selectedValue);
    const uniqueModelos = [...new Set(newPats.map(p => p.modelo_nome))].filter(m => m && m !== null && m !== undefined);
    if (selectedValue === 'Todos' && uniqueModelos.length > 1) {
      setSelectedModelos(prev => {
        const modelosRestantes = uniqueModelos.filter((modelo) => modelo !== 'Todos' && !prev.includes(modelo));
        return [...prev, ...modelosRestantes];
      });
      setShowModelos(prev => {
        const modelosRestantes = uniqueModelos.filter((modelo) => modelo !== 'Todos' && !prev.includes(modelo));
        return [...prev, ...modelosRestantes];
      });
    } else {
      setSelectedModelos(prev => {
        if (!prev.includes(selectedValue) && selectedValue !== 'Todos') {
          return [...prev, selectedValue];
        }
        return prev;
      });
      setShowModelos(prev => {
        if (!prev.includes(selectedValue) && selectedValue !== 'Todos') {
          return [...prev, selectedValue];
        }
        return prev;
      });
    }
  };

  const handleRemoveModelo = (index) => {
    setSelectedModelos(prev => {
      return prev.filter((_, i) => i !== index);
    });
    setShowModelos(prev => {
      return prev.filter((_, i) => i !== index);
    });
  };

  const removeAllModelos = () => {
    setSelectedModelos([]);
    setShowModelos([]);
  };

  // Funções para Grupos
  const handleGrupoChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedGrupoValue(selectedValue);
    if (selectedValue === 'Todos' && grupos && grupos.length > 1) {
      setSelectedGrupos(prev => {
        const gruposRestantes = grupos.filter((grupo) => !prev.includes(String(grupo.id)));
        return [...prev, ...gruposRestantes.map(g => String(g.id))];
      });
      setShowGrupos(prev => {
        const gruposRestantes = grupos.filter((grupo) => !prev.includes(grupo.nome));
        return [...prev, ...gruposRestantes.map(g => g.nome)];
      });
    } else if (selectedValue !== 'Todos') {
      setSelectedGrupos(prev => {
        if (!prev.includes(selectedValue)) {
          return [...prev, selectedValue];
        }
        return prev;
      });
      const grupoNome = grupos && grupos.find(g => String(g.id) === selectedValue)?.nome;
      if (grupoNome) {
        setShowGrupos(prev => {
          if (!prev.includes(grupoNome)) {
            return [...prev, grupoNome];
          }
          return prev;
        });
      }
    }
  };

  const handleRemoveGrupo = (index) => {
    setSelectedGrupos(prev => {
      return prev.filter((_, i) => i !== index);
    });
    setShowGrupos(prev => {
      return prev.filter((_, i) => i !== index);
    });
  };

  const removeAllGrupos = () => {
    setSelectedGrupos([]);
    setShowGrupos([]);
  };

  const handleSetorChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedSetorValue(selectedValue);
    if (selectedValue === 'Todos' && setor.length > 1) {
      setSelectedSetor(prev => {
        const setoresRestantes = setor.filter((setor) => setor !== 'Todos' && !prev.includes(setor));
        return [...prev, ...setoresRestantes];
      });
    } else if (selectedValue === 'Remover todos' && selectedSetor.length > 1) {

    } else {
      setSelectedSetor(prev => {
        if (!prev.includes(selectedValue) && selectedValue !== 'Todos') {
          return [...prev, selectedValue];
        }
        return prev;
      });
    }
  };

  const handleRemoveSetor = (index) => {
    setSelectedSetor(prev => {
      const removedSetor = prev[index];
      setSetor(prev => {
        if (!prev.includes(removedSetor)) {
          return [...prev, removedSetor];
        }
        return prev;
      });
      return prev.filter((_, i) => i !== index);
    });
  };

  const verifyAnexosBySetor = (f) => {
    let anex = new Set();
    f.forEach((pat) => {
      if (selectedSetor.includes(pat.setor)) {
        if (pat.nome_do_anexo && pat.nome_do_anexo !== null && pat.nome_do_anexo !== undefined) {
          anex.add(pat.nome_do_anexo);
        }
      }
    });
    setShowAnexos([...anex]);
  }

  const filteredPatrimonios = useMemo(() => {
    let filtered = newPats;
    if (selectedSetor.length > 0) {
      if (selectedAnexos.length > 0) {
        filtered = filtered.filter(p => selectedAnexos.includes(p.nome_do_anexo));
        verifyAnexosBySetor(filtered);
      } else {
        filtered = filtered.filter(p => selectedSetor.includes(p?.setor));
      }
    }
    if (selectedModelos.length > 0) {
      filtered = filtered.filter(p => selectedModelos.includes(p.modelo_nome));
    }
    if (selectedAnexos.length > 0) {
      if (selectedSetor.length > 0) {
        filtered = filtered.filter(p => selectedSetor.includes(p.setor));
      } else {
        filtered = filtered.filter(p => selectedAnexos.includes(p.nome_do_anexo));
      }
    }
    if (selectedGrupos.length > 0) {
      filtered = filtered.filter(p => selectedGrupos.includes(String(p.grupo_id)));
    }
    if (selectedSecretarias.length > 0) {
      filtered = filtered.filter(p => selectedSecretarias.includes(String(p.secretaria_id || p.id_secretaria)));
    }
    return filtered;
  }, [selectedSetor, selectedModelos, selectedAnexos, selectedGrupos, selectedSecretarias, newPats]);

  useEffect(() => {
    const newTotal = calculateTotalByGrupoValor(filteredPatrimonios);
    setFilteredTotal(newTotal);
  }, [filteredPatrimonios]);

  const handleSelectClient = (e) => {
    const id = e.target.value;
    setSelectedClient(id);
    const selectedClient = clientes.find((client) => client.id === parseInt(id));

    if (selectedClient) {
      setTitulo(selectedClient.nome);
      setIdCliente(id);
      setSelectedAnexos([]);
      setShowAnexos([]);
      setSelectedSetor([]);
      setSelectedModelos([]);
      setShowModelos([]);
      setSelectedModeloValue('');
      setSelectedGrupos([]);
      setShowGrupos([]);
      setSelectedGrupoValue('');
      setSelectedSecretarias([]);
      setShowSecretarias([]);
      setSelectedSecretariaValue('');
      setClienteSelecionado(selectedClient.nome);
    } else {
      setClienteSelecionado('');
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  const eraseFilter = () => {
    setFilterDates({ dataInicio: null, dataFim: null, checkUpdate: false });
    const client = clientes.find((client) => client.nome === clienteSelecionado);
    setIdCliente(client.id);
  };

  const handleDateModal = () => {
    setFilterModal(!filterModal);
  };

  const handleUnique = () => {
    // Filtrar patrimonios para excluir anexo "ESTOQUE"
    const patrimoniosFiltered = patrimonios.filter(pat => 
      pat.nome_do_anexo !== "ESTOQUE" && pat.nome_do_anexo !== "Estoque" && pat.nome_do_anexo !== "estoque"
    );
    
    const uniqueAnexos = [...new Set(patrimoniosFiltered.map(p => p.nome_do_anexo).filter(a => a && a !== null && a !== undefined))];
    const uniqueSetor = [...new Set(patrimoniosFiltered.map(p => p.setor).filter(s => s && s !== null && s !== undefined))];
    if (uniqueSetor.length > 1) {
      uniqueSetor.unshift('Todos');
      setSetor(uniqueSetor);
    }
    if (uniqueAnexos.length > 1) {
      uniqueAnexos.unshift('Todos');
      setAnexos(uniqueAnexos);
    }
  }

  useEffect(() => {
    handleUnique();
  }, [patrimonios]);

  useEffect(() => {
    setSetor(prev => prev.filter(setor => !selectedSetor.includes(setor)));
  }, [selectedSetor]);

  // useEffect(() => {
  //   setAnexos(prevAnexos => prevAnexos.filter(anexo => !selectedAnexos.includes(anexo)));
  // }, [selectedAnexos, showAnexos]);

  const headers = [
    // filteredPatrimonios[0]?.data_implantacao && { label: "Data Implantação", key: "data_implantacao", sortable: false, width: "w-32" },
    { label: "Anexo", key: "nome_do_anexo", sortable: true, wrapText: true, width: "w-40" },
    { label: "Setor", key: "setor", sortable: false, width: "w-32" },
    { label: "Nome", key: "pat_nome", sortable: false, wrapText: true, width: "w-40" },
    { label: "Ramal", key: "ramal", sortable: false, width: "w-24" },
    { label: "Equipamento", key: "produto", sortable: false, wrapText: true, width: "w-48" },
    { label: "Marca", key: "marca_nome", sortable: false, width: "w-32" },
    { label: "Modelo", key: "modelo_nome", sortable: false, width: "w-32" },
    { label: "Grupo de Equipamento", key: "grupo_nome", sortable: false, wrapText: true, width: "w-40" },
    { label: "Valor do Item", key: "grupo_valor", sortable: false, width: "w-32", type: "money" },
    { label: "MAC", key: "nmac", sortable: false, width: "w-36" },
    { label: "Número de Série", key: "nserie", sortable: false, width: "w-36" },
    { label: "Nº Etiqueta", key: "netiqueta", sortable: false, width: "w-24" },
    // { label: "Valor", key: "valor_cobrado", sortable: false, width: "w-32" },
    ].filter((header) => header);

  return (
    <>
      {/* Cabeçalho: cliente, data, resumo e filtros em uma linha */}
      <div className="flex flex-wrap items-end gap-4 mb-6">
        <div className="w-full md:w-[420px] lg:w-[520px] xl:w-[620px] flex-none">
          <BaseSelect
            name="cliente"
            value={selectedClient}
            onChange={handleSelectClient}
            options={clientes ? clientes.slice().sort((a, b) => a.nome.localeCompare(b.nome)) : []}
            placeholder="Cliente"
            valueKey="id"
            labelKey="nome"
          />
        </div>

        {/* Resumo inline */}

        {/* Resumo inline */}
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-2 bg-gradient-to-r from-vox-blue-50 to-vox-blue-100 dark:from-vox-blue-900/20 dark:to-vox-blue-800/20 border border-vox-blue-200 dark:border-vox-blue-700 rounded-lg px-3 py-2 shadow-sm">
            <div className="w-7 h-7 bg-vox-blue-500 rounded-lg flex items-center justify-center">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 00-2 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14" />
              </svg>
            </div>
            <div>
              <p className="text-[11px] leading-3 font-medium text-vox-blue-600 dark:text-vox-blue-400">Aparelhos</p>
              <p className="text-base font-bold text-vox-blue-800 dark:text-vox-blue-300">{filteredPatrimonios.length}</p>
            </div>
          </div>
          <div className="flex items-center gap-2 bg-gradient-to-r from-vox-green-50 to-vox-green-100 dark:from-vox-green-900/20 dark:to-vox-green-800/20 border border-vox-green-200 dark:border-vox-green-700 rounded-lg px-3 py-2 shadow-sm">
            <div className="w-7 h-7 bg-vox-green-500 rounded-lg flex items-center justify-center">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
              </svg>
            </div>
            <div>
              <p className="text-[11px] leading-3 font-medium text-vox-green-600 dark:text-vox-green-400">Valor Total</p>
              <p className="text-base font-bold text-vox-green-800 dark:text-vox-green-300">{toBrl(filteredTotal)}</p>
            </div>
          </div>
        </div>

        <div className="relative ml-auto flex items-center gap-3">
          <button
            onClick={() => setShowFilters(!showFilters)}
            className="w-full lg:w-auto inline-flex items-center justify-center px-4 py-2 bg-gradient-to-r from-vox-blue-600 to-vox-blue-700 hover:from-vox-blue-700 hover:to-vox-blue-800 text-white font-medium rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-vox-blue-500 focus:ring-offset-2"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z" />
            </svg>
            Filtros Avançados
            <svg className={`w-4 h-4 ml-2 transition-transform duration-200 ${showFilters ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          {/* Botão Filtrar por Data depois dos filtros avançados */}
          {!filterDates.dataInicio && !filterDates.dataFim ? (
            <button
              onClick={() => setFilterModal(true)}
              className="inline-flex items-center px-3 py-2 bg-gradient-to-r from-vox-green-600 to-vox-green-700 hover:from-vox-green-700 hover:to-vox-green-800 text-white font-medium rounded-lg shadow-sm hover:shadow-md transform hover:scale-105 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-vox-green-500 focus:ring-offset-2"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Filtrar por Data
            </button>
          ) : (
            <div className="flex items-center gap-2 p-2 bg-gradient-to-r from-vox-green-50 to-vox-blue-50 dark:from-vox-green-900/20 dark:to-vox-blue-900/20 border border-vox-green-200 dark:border-vox-green-700 rounded-lg">
              <span className="text-xs"><span className="font-medium">De:</span> {formatDate(filterDates.dataInicio)}</span>
              <span className="text-xs"><span className="font-medium">Até:</span> {formatDate(filterDates.dataFim)}</span>
              {checkUpdate && (
                <span className="px-2 py-0.5 bg-green-100 text-green-800 border border-green-300 rounded text-xs">Atualização</span>
              )}
              <button
                onClick={eraseFilter}
                className="p-1 text-vox-red-600 hover:text-vox-red-700 hover:bg-vox-red-50 dark:hover:bg-vox-red-900/20 rounded transition-colors duration-200"
                title="Limpar filtro de data"
              >
                <BiX className="w-4 h-4" />
              </button>
            </div>
          )}


          {/* Dropdown de Filtros */}
          {showFilters && (
            <div className="absolute top-full right-0 mt-2 w-96 bg-white dark:bg-gray-800 rounded-xl shadow-vox-2xl border border-gray-200 dark:border-gray-700 z-50">
              <div className="p-6 space-y-4">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                  Filtros Avançados
                </h3>

                {/* Secretaria */}
                <BaseSelect
                  label="Secretaria"
                  name="secretaria"
                  value={selectedSecretariaValue}
                  onChange={handleSecretariaChange}
                  options={[{ id: 'Todos', nome: 'Todos' }, ...secretariaOptions]}
                  placeholder="Selecione a secretaria"
                  valueKey="id"
                  labelKey="nome"
                />

                {/* Setor */}
                <BaseSelect
                  label="Setor"
                  name="setor"
                  value={selectedSetorValue}
                  onChange={handleSetorChange}
                  options={setor.filter(s => s && s !== null && s !== undefined).map(s => ({ id: s, nome: s }))}
                  placeholder="Selecione o setor"
                  valueKey="id"
                  labelKey="nome"
                />

                {/* Anexo */}
                <BaseSelect
                  label="Anexo"
                  name="anexo"
                  value={selectedAnexoValue}
                  onChange={handleAnexoChange}
                  options={anexos.filter(a => a && a !== null && a !== undefined).map(a => ({ id: a, nome: a }))}
                  placeholder="Selecione o anexo"
                  valueKey="id"
                  labelKey="nome"
                />

                {/* Modelo */}
                <BaseSelect
                  label="Modelo"
                  name="modelo"
                  value={selectedModeloValue}
                  onChange={handleModeloChange}
                  options={[{ id: 'Todos', nome: 'Todos' }, ...[...new Set(newPats.map(p => p.modelo_nome))].filter(m => m && m !== null && m !== undefined).map(m => ({ id: m, nome: m }))]}
                  placeholder="Selecione o modelo"
                  valueKey="id"
                  labelKey="nome"
                />

                {/* Grupo */}
                <BaseSelect
                  label="Grupo"
                  name="grupo"
                  value={selectedGrupoValue}
                  onChange={handleGrupoChange}
                  options={grupos && grupos.length > 0 ? [{ id: 'Todos', nome: 'Todos' }, ...grupos.map(g => ({ id: String(g.id), nome: g.nome }))] : []}
                  placeholder="Selecione o grupo"
                  valueKey="id"
                  labelKey="nome"
                />

                {/* Botões do Dropdown */}
                <div className="flex justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
                  <button
                    onClick={() => {
                      // Limpar todos os filtros
                      setSelectedSecretariaValue('');
                      setSelectedSecretarias([]);
                      setShowSecretarias([]);
                      setSelectedSetorValue('');
                      setSelectedSetor([]);
                      setSelectedAnexoValue('');
                      setSelectedAnexos([]);
                      setSelectedModeloValue('');
                      setSelectedModelos([]);
                      setShowModelos([]);
                      setSelectedGrupoValue('');
                      setSelectedGrupos([]);
                      setShowGrupos([]);
                      removeAllAnexos();
                      removeAllSetores();
                      removeAllSecretarias();
                      removeAllModelos();
                      removeAllGrupos();
                    }}
                    className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-600 border border-gray-300 dark:border-gray-500 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-500 transition-colors duration-200"
                  >
                    Limpar
                  </button>
                  <button
                    onClick={() => setShowFilters(false)}
                    className="px-4 py-2 bg-gradient-to-r from-vox-green-600 to-vox-green-700 hover:from-vox-green-700 hover:to-vox-green-800 text-white font-medium rounded-lg transition-all duration-200"
                  >
                    Aplicar
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Filtro de data já embutido no cabeçalho */}

             {/* Seleções Ativas - Dropdown inline */}
       {(selectedSetor.length > 0 || showAnexos.length > 0 || showSecretarias.length > 0 || showModelos.length > 0 || showGrupos.length > 0) && (
         <div className="mb-4">
           <div className="relative inline-block">
             <button
               onClick={() => setShowSelections(!showSelections)}
               className="inline-flex items-center px-3 py-2 bg-gradient-to-r from-vox-orange-600 to-vox-orange-700 
               hover:from-vox-orange-700 
               hover:to-vox-orange-800 font-medium rounded-lg shadow-sm 
               hover:shadow-md transition-all duration-200 
               focus:outline-none focus:ring-2 
               focus:ring-vox-orange-500 focus:ring-offset-2
               text-black dark:text-white
               "
             >
               <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
               </svg>
               Seleções Ativas ({selectedSetor.length + showAnexos.length + showSecretarias.length + showModelos.length + showGrupos.length})
               <svg className={`w-4 h-4 ml-2 transition-transform duration-200 ${showSelections ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
               </svg>
             </button>

             {showSelections && (
               <div className="absolute top-full left-0 mt-2 w-[1200px] h-[760px] bg-gradient-to-br from-white to-gray-50/50 dark:bg-gradient-to-br dark:from-gray-800 dark:to-gray-900/50 rounded-2xl shadow-vox-2xl border border-gray-200/50 dark:border-gray-700/50 z-50 flex flex-col backdrop-blur-sm">
                 <div className="p-8 flex-1 overflow-y-auto">
                   <div className="flex items-center justify-between mb-6">
                     <h3 className="text-2xl font-semibold text-gray-900 dark:text-white">
                       Filtros Aplicados
                     </h3>
                     <button
                       onClick={() => {
                         removeAllSetores();
                         removeAllAnexos();
                         removeAllSecretarias();
                         removeAllModelos();
                         removeAllGrupos();
                         setSearchSetor('');
                         setSearchAnexo('');
                         setSearchSecretaria('');
                         setSearchModelo('');
                         setSearchGrupo('');
                         setShowSelections(false);
                       }}
                       className="px-6 py-3 text-lg font-bold text-red-700 hover:text-white dark:text-red-400 dark:hover:text-white bg-gradient-to-r from-red-100 to-red-200 hover:from-red-500 hover:to-red-600 dark:from-red-900/20 dark:to-red-800/20 dark:hover:from-red-600 dark:hover:to-red-700 rounded-xl border-2 border-red-300 dark:border-red-700/50 shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-105"
                     >
                       Limpar tudo
                     </button>
                   </div>
                   
                   <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
                     {/* Caixa de Setores */}
                     {selectedSetor.length > 0 && (
                       <div className="bg-gradient-to-br from-blue-50 to-blue-100/50 dark:bg-gradient-to-br dark:from-blue-900/20 dark:to-blue-800/10 rounded-xl p-6 border border-blue-200/50 dark:border-blue-700/50 shadow-sm">
                         <div className="flex items-center justify-between mb-4">
                           <h4 className="text-lg font-semibold text-blue-800 dark:text-blue-300 flex items-center gap-3">
                             <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0h3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                             </svg>
                             Setores ({selectedSetor.filter(setor => setor.toLowerCase().includes(searchSetor.toLowerCase())).length})
                           </h4>
                           <button
                             onClick={removeAllSetores}
                             className="text-sm font-bold text-red-700 hover:text-white dark:text-red-400 dark:hover:text-white bg-red-50 hover:bg-red-500 dark:bg-gray-700 dark:hover:bg-red-600 px-4 py-2 rounded-lg border-2 border-red-300 dark:border-red-700/50 shadow-sm hover:shadow-md transition-all duration-200 transform hover:scale-105"
                           >
                             Remover todos
                           </button>
                         </div>
                         
                         {/* Input de pesquisa para setores */}
                         <div className="relative mb-4">
                           <svg className="absolute left-4 top-1/2 transform -translate-y-1/2 w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                           </svg>
                           <input
                             type="text"
                             placeholder="Pesquisar setores..."
                             value={searchSetor}
                             onChange={(e) => setSearchSetor(e.target.value)}
                             className="w-full pl-14 pr-4 py-4 text-lg bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                           />
                         </div>
                         
                         <div className="flex flex-wrap gap-2 max-h-96 overflow-y-auto">
                           {selectedSetor
                             .filter(setor => setor.toLowerCase().includes(searchSetor.toLowerCase()))
                             .map((setor, index) => {
                               const originalIndex = selectedSetor.findIndex(s => s === setor);
                               return (
                                 <span
                                   key={`${setor}-${originalIndex}`}
                                   className="inline-flex items-center gap-3 px-5 py-4 bg-gradient-to-r from-blue-50 to-blue-100 text-gray-900 dark:bg-gradient-to-r dark:from-blue-900/40 dark:to-blue-800/40 dark:text-blue-200 text-lg rounded-xl border border-blue-200/50 dark:border-blue-600/50 shadow-sm hover:shadow-md transition-all duration-200"
                                 >
                                   {setor}
                                   <button
                                     onClick={() => handleRemoveSetor(originalIndex)}
                                     className="text-gray-600 hover:text-red-600 hover:bg-white/80 dark:text-blue-300 dark:hover:text-red-400 dark:hover:bg-blue-700/50 rounded-full p-1 transition-all duration-200 hover:scale-110"
                                     title="Remover setor"
                                   >
                                     <BiX className="w-6 h-6" />
                                   </button>
                                 </span>
                               );
                             })}
                         </div>
                       </div>
                     )}

                     {/* Caixa de Anexos */}
                     {showAnexos.length > 0 && (
                       <div className="bg-gradient-to-br from-green-50 to-green-100/50 dark:bg-gradient-to-br dark:from-green-900/20 dark:to-green-800/10 rounded-xl p-6 border border-green-200/50 dark:border-green-700/50 shadow-sm">
                         <div className="flex items-center justify-between mb-4">
                           <h4 className="text-lg font-semibold text-green-800 dark:text-green-300 flex items-center gap-3">
                             <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                             </svg>
                             Anexos ({showAnexos.filter(anexo => anexo.toLowerCase().includes(searchAnexo.toLowerCase())).length})
                           </h4>
                           <button
                             onClick={removeAllAnexos}
                             className="text-sm font-bold text-red-700 hover:text-white dark:text-red-400 dark:hover:text-white bg-red-50 hover:bg-red-500 dark:bg-gray-700 dark:hover:bg-red-600 px-4 py-2 rounded-lg border-2 border-red-300 dark:border-red-700/50 shadow-sm hover:shadow-md transition-all duration-200 transform hover:scale-105"
                           >
                             Remover todos
                           </button>
                         </div>
                         
                         {/* Input de pesquisa para anexos */}
                         <div className="relative mb-4">
                           <svg className="absolute left-4 top-1/2 transform -translate-y-1/2 w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                           </svg>
                           <input
                             type="text"
                             placeholder="Pesquisar anexos..."
                             value={searchAnexo}
                             onChange={(e) => setSearchAnexo(e.target.value)}
                             className="w-full pl-14 pr-4 py-4 text-lg bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                           />
                         </div>
                         
                         <div className="flex flex-wrap gap-2 max-h-96 overflow-y-auto">
                           {showAnexos
                             .filter(anexo => anexo.toLowerCase().includes(searchAnexo.toLowerCase()))
                             .map((anexo, index) => {
                               const originalIndex = showAnexos.findIndex(a => a === anexo);
                               return (
                                 <span
                                   key={`${anexo}-${originalIndex}`}
                                   className="inline-flex items-center gap-3 px-5 py-4 bg-gradient-to-r from-green-50 to-green-100 text-gray-900 dark:bg-gradient-to-r dark:from-green-900/40 dark:to-green-800/40 dark:text-green-200 text-lg rounded-xl border border-green-200/50 dark:border-green-600/50 shadow-sm hover:shadow-md transition-all duration-200"
                                 >
                                   {anexo}
                                   <button
                                     onClick={() => handleRemoveAnexo(originalIndex)}
                                     className="text-gray-600 hover:text-red-600 hover:bg-white/80 dark:text-green-300 dark:hover:text-red-400 dark:hover:bg-green-700/50 rounded-full p-1 transition-all duration-200 hover:scale-110"
                                     title="Remover anexo"
                                   >
                                     <BiX className="w-6 h-6" />
                                   </button>
                                 </span>
                               );
                             })}
                         </div>
                       </div>
                     )}

                     {/* Caixa de Secretarias */}
                     {showSecretarias.length > 0 && (
                       <div className="bg-gradient-to-br from-purple-50 to-purple-100/50 dark:bg-gradient-to-br dark:from-purple-900/20 dark:to-purple-800/10 rounded-xl p-6 border border-purple-200/50 dark:border-purple-700/50 shadow-sm">
                         <div className="flex items-center justify-between mb-4">
                           <h4 className="text-lg font-semibold text-purple-800 dark:text-purple-300 flex items-center gap-3">
                             <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0h3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                             </svg>
                             Secretarias ({showSecretarias.filter(sec => sec.toLowerCase().includes(searchSecretaria.toLowerCase())).length})
                           </h4>
                           <button
                             onClick={removeAllSecretarias}
                             className="text-sm font-bold text-red-700 hover:text-white dark:text-red-400 dark:hover:text-white bg-red-50 hover:bg-red-500 dark:bg-gray-700 dark:hover:bg-red-600 px-4 py-2 rounded-lg border-2 border-red-300 dark:border-red-700/50 shadow-sm hover:shadow-md transition-all duration-200 transform hover:scale-105"
                           >
                             Remover todos
                           </button>
                         </div>
                         
                         {/* Input de pesquisa para secretarias */}
                         <div className="relative mb-4">
                           <svg className="absolute left-4 top-1/2 transform -translate-y-1/2 w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                           </svg>
                           <input
                             type="text"
                             placeholder="Pesquisar secretarias..."
                             value={searchSecretaria}
                             onChange={(e) => setSearchSecretaria(e.target.value)}
                             className="w-full pl-14 pr-4 py-4 text-lg bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                           />
                         </div>
                         
                         <div className="flex flex-wrap gap-2 max-h-96 overflow-y-auto">
                           {showSecretarias
                             .filter(sec => sec.toLowerCase().includes(searchSecretaria.toLowerCase()))
                             .map((secretaria, index) => {
                               const originalIndex = showSecretarias.findIndex(s => s === secretaria);
                               return (
                                 <span
                                   key={`${secretaria}-${originalIndex}`}
                                   className="inline-flex items-center gap-3 px-5 py-4 bg-gradient-to-r from-purple-50 to-purple-100 text-gray-900 dark:bg-gradient-to-r dark:from-purple-900/40 dark:to-purple-800/40 dark:text-purple-200 text-lg rounded-xl border border-purple-200/50 dark:border-purple-600/50 shadow-sm hover:shadow-md transition-all duration-200"
                                 >
                                   {secretaria}
                                   <button
                                     onClick={() => handleRemoveSecretaria(originalIndex)}
                                     className="text-gray-600 hover:text-red-600 hover:bg-white/80 dark:text-purple-300 dark:hover:text-red-400 dark:hover:bg-purple-700/50 rounded-full p-1 transition-all duration-200 hover:scale-110"
                                     title="Remover secretaria"
                                   >
                                     <BiX className="w-6 h-6" />
                                   </button>
                                 </span>
                               );
                             })}
                         </div>
                       </div>
                     )}

                     {/* Caixa de Modelos */}
                     {showModelos.length > 0 && (
                       <div className="bg-gradient-to-br from-orange-50 to-orange-100/50 dark:bg-gradient-to-br dark:from-orange-900/20 dark:to-orange-800/10 rounded-xl p-6 border border-orange-200/50 dark:border-orange-700/50 shadow-sm">
                         <div className="flex items-center justify-between mb-4">
                           <h4 className="text-lg font-semibold text-orange-800 dark:text-orange-300 flex items-center gap-3">
                             <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                             </svg>
                             Modelos ({showModelos.filter(mod => mod.toLowerCase().includes(searchModelo.toLowerCase())).length})
                           </h4>
                           <button
                             onClick={removeAllModelos}
                             className="text-sm font-bold text-red-700 hover:text-white dark:text-red-400 dark:hover:text-white bg-red-50 hover:bg-red-500 dark:bg-gray-700 dark:hover:bg-red-600 px-4 py-2 rounded-lg border-2 border-red-300 dark:border-red-700/50 shadow-sm hover:shadow-md transition-all duration-200 transform hover:scale-105"
                           >
                             Remover todos
                           </button>
                         </div>
                         
                         {/* Input de pesquisa para modelos */}
                         <div className="relative mb-4">
                           <svg className="absolute left-4 top-1/2 transform -translate-y-1/2 w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                           </svg>
                           <input
                             type="text"
                             placeholder="Pesquisar modelos..."
                             value={searchModelo}
                             onChange={(e) => setSearchModelo(e.target.value)}
                             className="w-full pl-14 pr-4 py-4 text-lg bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                           />
                         </div>
                         
                         <div className="flex flex-wrap gap-2 max-h-96 overflow-y-auto">
                           {showModelos
                             .filter(mod => mod.toLowerCase().includes(searchModelo.toLowerCase()))
                             .map((modelo, index) => {
                               const originalIndex = showModelos.findIndex(m => m === modelo);
                               return (
                                 <span
                                   key={`${modelo}-${originalIndex}`}
                                   className="inline-flex items-center gap-3 px-5 py-4 bg-gradient-to-r from-orange-50 to-orange-100 text-gray-900 dark:bg-gradient-to-r dark:from-orange-900/40 dark:to-orange-800/40 dark:text-orange-200 text-lg rounded-xl border border-orange-200/50 dark:border-orange-600/50 shadow-sm hover:shadow-md transition-all duration-200"
                                 >
                                   {modelo}
                                   <button
                                     onClick={() => handleRemoveModelo(originalIndex)}
                                     className="text-gray-600 hover:text-red-600 hover:bg-white/80 dark:text-orange-300 dark:hover:text-red-400 dark:hover:bg-orange-700/50 rounded-full p-1 transition-all duration-200 hover:scale-110"
                                     title="Remover modelo"
                                   >
                                     <BiX className="w-6 h-6" />
                                   </button>
                                 </span>
                               );
                             })}
                         </div>
                       </div>
                     )}

                     {/* Caixa de Grupos */}
                     {showGrupos.length > 0 && (
                       <div className="bg-gradient-to-br from-indigo-50 to-indigo-100/50 dark:bg-gradient-to-br dark:from-indigo-900/20 dark:to-indigo-800/10 rounded-xl p-6 border border-indigo-200/50 dark:border-indigo-700/50 shadow-sm">
                         <div className="flex items-center justify-between mb-4">
                           <h4 className="text-lg font-semibold text-indigo-800 dark:text-indigo-300 flex items-center gap-3">
                             <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                             </svg>
                             Grupos ({showGrupos.filter(grp => grp.toLowerCase().includes(searchGrupo.toLowerCase())).length})
                           </h4>
                           <button
                             onClick={removeAllGrupos}
                             className="text-sm font-bold text-red-700 hover:text-white dark:text-red-400 dark:hover:text-white bg-red-50 hover:bg-red-500 dark:bg-gray-700 dark:hover:bg-red-600 px-4 py-2 rounded-lg border-2 border-red-300 dark:border-red-700/50 shadow-sm hover:shadow-md transition-all duration-200 transform hover:scale-105"
                           >
                             Remover todos
                           </button>
                         </div>
                         
                         {/* Input de pesquisa para grupos */}
                         <div className="relative mb-4">
                           <svg className="absolute left-4 top-1/2 transform -translate-y-1/2 w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                           </svg>
                           <input
                             type="text"
                             placeholder="Pesquisar grupos..."
                             value={searchGrupo}
                             onChange={(e) => setSearchGrupo(e.target.value)}
                             className="w-full pl-14 pr-4 py-4 text-lg bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                           />
                         </div>
                         
                         <div className="flex flex-wrap gap-2 max-h-96 overflow-y-auto">
                           {showGrupos
                             .filter(grp => grp.toLowerCase().includes(searchGrupo.toLowerCase()))
                             .map((grupo, index) => {
                               const originalIndex = showGrupos.findIndex(g => g === grupo);
                               return (
                                 <span
                                   key={`${grupo}-${originalIndex}`}
                                   className="inline-flex items-center gap-3 px-5 py-4 bg-gradient-to-r from-indigo-50 to-indigo-100 text-gray-900 dark:bg-gradient-to-r dark:from-indigo-900/40 dark:to-indigo-800/40 dark:text-indigo-200 text-lg rounded-xl border border-indigo-200/50 dark:border-indigo-600/50 shadow-sm hover:shadow-md transition-all duration-200"
                                 >
                                   {grupo}
                                   <button
                                     onClick={() => handleRemoveGrupo(originalIndex)}
                                     className="text-gray-600 hover:text-red-600 hover:bg-white/80 dark:text-indigo-300 dark:hover:text-red-400 dark:hover:bg-indigo-700/50 rounded-full p-1 transition-all duration-200 hover:scale-110"
                                     title="Remover grupo"
                                   >
                                     <BiX className="w-6 h-6" />
                                   </button>
                                 </span>
                               );
                             })}
                         </div>
                       </div>
                     )}
                   </div>
                 </div>
               </div>
             )}
           </div>
         </div>
       )}


      {loading && <LoadingSpinner />}
      {filteredPatrimonios && <DataTable headers={headers} data={filteredPatrimonios} itemsPerPage={5} exportButton={true} docTitle={`Dados gerais do cliente ${titulo}`} fontHeader={8} fontData={7} footerValues={["Valor Total", toBrl(filteredTotal)]}/>}
      {filterModal && <FilterDate filterDates={filterDates} setFilterDates={setFilterDates} closeModal={handleDateModal} checkUpdate={checkUpdate} setCheckUpdate={setCheckUpdate} />}
    </>
  );
};

export default Setor;
